import { MouseEvent, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { Button, Checkbox } from '@zep/ui';
import { getChannelTalkSupportArticleUrl } from '@zep/utils';
import { SingularSubscriptionPaymentResponse } from '../../../../../types/PaymentTypes';
import { fCurrency } from '../../../../../utils';
import S from '../../../business/BusinessPayments.module.scss';
import { PlanCheckoutFormSchemaType } from '../hooks/usePlanCheckoutForm';
import { SingularPaymentInformation } from './SingularPaymentInformation';
export const SingularPaymentForm = ({
  businessName,
  paymentInformation,
  onSubmit,
  productName
}: SingularSubscriptionPaymentsInfoProps) => {
  const {
    locale = 'ko'
  } = useRouter();
  const {
    t
  } = useTranslation(['manage']);
  const [[isPayAgreed, isTermsAgreed], setAgreed] = useState([false, false]);
  const {
    formState: {
      errors
    }
  } = useFormContext<PlanCheckoutFormSchemaType>();
  const finalPrice = paymentInformation.priceInfo?.finalPrice;
  const hasPriceSnapshot = typeof finalPrice === 'number' && finalPrice > 0;
  const handleAgree = (type: 'isPayAgreed' | 'isTermsAgreed') => {
    if (type === 'isPayAgreed') {
      setAgreed(prevState => [!prevState[0], prevState[1]]);
      return;
    }
    setAgreed(prevState => [prevState[0], !prevState[1]]);
    return;
  };
  const openTermsWindow = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    if ((event.target as HTMLElement).nodeName !== 'A') {
      return;
    }
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const windowWidth = 500;
    const windowHeight = 900;
    const left = (screenWidth - windowWidth) / 2;
    const top = (screenHeight - windowHeight - 100) / 2;
    window.open(getChannelTalkSupportArticleUrl(locale, 'b40ac18f'), '_blank', `width=${windowWidth},height=${windowHeight},left=${left},top=${top}`);
  };
  return <>
      <SingularPaymentInformation customerName={businessName} productName={productName} paymentInformation={paymentInformation} data-sentry-element="SingularPaymentInformation" data-sentry-source-file="SingularPaymentForm.tsx" />
      <div className={S.payments_final}>
        <div>
          {t('manage:donate_final_payment')}{' '}
          <b>
            {hasPriceSnapshot ? fCurrency(finalPrice, paymentInformation.spacePlan.currency, {
            position: 'pre',
            currencyString: '₩'
          }) : '-'}
          </b>
        </div>

        <Checkbox circle checked={isPayAgreed} label={t('manage:donate_payment_check_amount')} onChange={() => handleAgree('isPayAgreed')} data-sentry-element="Checkbox" data-sentry-source-file="SingularPaymentForm.tsx" />
        <Checkbox circle checked={isTermsAgreed} onChange={() => handleAgree('isTermsAgreed')} label={<div className={S.with_terms} onClick={openTermsWindow} dangerouslySetInnerHTML={{
        // @ts-ignore
        __html: t('business:businessPage.payment.termsAgreement')
      }}></div>} data-sentry-element="Checkbox" data-sentry-source-file="SingularPaymentForm.tsx" />
      </div>
      <Button size="lg" disabled={!hasPriceSnapshot || !isPayAgreed || !isTermsAgreed || !!Object.keys(errors).length} onClick={onSubmit} data-sentry-element="Button" data-sentry-source-file="SingularPaymentForm.tsx">
        {t('manage:donate_payment_creditcard')}
        &nbsp;
        {t('manage:donate_payment_pay')}
      </Button>
    </>;
};
export type SingularSubscriptionPaymentsInfoProps = {
  paymentHashId: string;
  businessName: string;
  paymentInformation: SingularSubscriptionPaymentResponse;
  onSubmit: () => void;
  productName: string;
};